module.exports = __webpack_public_path__ + "static/img/ys2.34020b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/control2/ys2.png
// module id = Mn/+
// module chunks = 7